import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import './Sidenav.css'

const Sidenav = (props) => {

	const isSidenavOpen = props.isSidenavOpen
	const setSidenavOpen = props.setSidenavOpen
	const setSketchbookDetailOpen = props.setSketchbookDetailOpen

	const sidenavopenClass = isSidenavOpen ? 'sidenavopen' : '';

	return (
		<div className={`sidenav ${sidenavopenClass}`}>
			<div className='sidenavclose' onClick={() => setSidenavOpen(false)}>
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
					<path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
				</svg>
			</div>
			<div className='sidenavcontent'>
				<Link to={"/"}>Home</Link>
				<Link to={"/grayson-as-claire"}>Grayson Perry as Claire</Link>
				<Link onClick={setSketchbookDetailOpen}>Gallery</Link>
				<Link to={"/about"}>About</Link>
				{/* <Link to={"/contact"}>Contact</Link> */}
			</div>
		</div>
	);

};

export default Sidenav;